/**
 * Shared tab values for landing page URLs.
 * Used by routing, links, and cross-view navigation (e.g. redirects).
 * Each landing view defines its own tab enum; these values align with URL params.
 */
/* eslint-disable import/prefer-default-export */
export enum LandingTab {
  Overview = 'overview',
  LiveClass = 'live_class',
  WhatsNext = 'whats_next',
  PremiumSessions = 'premium_sessions',
}
